export default {
  labels: {
    invoice: 'Factuur',
    on_site: 'Betalen ter plaatse (contant/kaart)',
  },
};
